import { IScoreType, ISport } from 'bets.oddprovider.lib.common.ts/models'
import { NumberUtils } from 'fwork-jsts-common/src'
import { ApiClientUtils } from 'fwork-jsts-common/src/apiClient'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import { useSnackbar } from 'notistack'
import * as React from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DEFAULTGAP, RoutesNames } from '../../globals'
import { toggleLoading } from '../../redux/reducers/loadingBar.slice'
import { IScoreTypesState, scoreTypesStateLoadFromApi } from '../../redux/reducers/scoreTypes.slice'
import { RootState } from '../../redux/store'
import { HeaderComponent } from '../common/header'
import { SearchInputComponent } from '../common/searchInput'
import { SportsApiClient } from '../../apiClient/sports'
import axios from "../../apiClient/axios"

export const ScoreTypesComponent = () => {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch<any>()

  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const scoreTypesState: IScoreTypesState = useSelector((state: RootState) => state.scoreTypesState)
  const scoreTypes = [...scoreTypesState.payload || []]

  const [searchText, setSearchText] = useState<string | undefined>()

  const loadScoreTypes = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<IScoreType> | undefined = searchText ? {
      $or: [
        {
          name: { $regex: searchText, $options: 'i' },
        },
        {
          id: NumberUtils.onlyNumbers(searchText)
        }]
    } : undefined

    const response = await dispatch(scoreTypesStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      paddingBottom: DEFAULTGAP
    }}>
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Tipos de Resultados'
        onRefreshClick={loadScoreTypes}
        onAddClick={() => navigate(RoutesNames.scoreType)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por código ou nome'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadScoreTypes() }}
        onIconClick={loadScoreTypes}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={scoreTypes}
        bodyRowBuilder={(scoreType: IScoreType) => <StyledTableCell>
          <StyledListItemText
            primary={scoreType.name}
            secondary={scoreType.id}
          />
          <div style={{ paddingTop: 5 }}>{scoreType.sport?.name}</div>
        </StyledTableCell>}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: IScoreType) => {
            navigate(RoutesNames.scoreType.replace(':id', item?.id.toString()))
          }
        }}
      />
    </div>
  </>
}